import { Model } from '../index.js';
export const PLATFORM_BASE_ALTERNATIVE_MAP = {
    [Model.AnchorSinglePlatformBase.type]: Model.AnchorBase.type,
    [Model.BellhouseSinglePlatformBase.type]: Model.BellhouseBase.type,
    [Model.BellyStretchedBase.type]: Model.MeredithBase.type,
    [Model.FranklinSinglePlatformBase.type]: Model.FranklinBase.type,
    [Model.MeredithSinglePlatformBase.type]: Model.MeredithBase.type,
    [Model.TuscanSinglePlatformBase.type]: Model.TuscanBase.type,
    [Model.PeruStretchedBase.type]: Model.MeredithBase.type,
    [Model.RogersSinglePlatformBase.type]: Model.RogersBase.type
};
export const SINGLE_BASE_ALTERNATIVE_MAP = {
    [Model.AnchorBase.type]: Model.AnchorSingleFeetBase.type,
    [Model.BellhouseBase.type]: Model.BellhouseSingleFeetBase.type,
    [Model.BrewerBase.type]: Model.BrewerSingleBase.type,
    [Model.CaseyBase.type]: Model.CaseyBase.type,
    [Model.CraftsmanBase.type]: Model.CraftsmanSingleBase.type,
    [Model.CrescentBase.type]: Model.CrescentSingleBase.type,
    [Model.DanaBase.type]: Model.DanaSingleBase.type,
    [Model.FranklinBase.type]: Model.FranklinSingleFeetBase.type,
    [Model.HershBase.type]: Model.HershBase.type,
    [Model.MeredithBase.type]: Model.MeredithSingleFeetBase.type,
    [Model.OswaldBase.type]: Model.OswaldSingleBase.type,
    [Model.RishBase.type]: Model.RishSingleBase.type,
    [Model.RogersBase.type]: Model.RogersSinglePlatformBase.type,
    [Model.TamaraBase.type]: Model.TamaraSingleBase.type,
    [Model.TuscanBase.type]: Model.TuscanSingleFeetBase.type,
    [Model.WaldenBase.type]: Model.WaldenSingleBase.type,
    [Model.XBase.type]: Model.XSingleBase.type,
    [Model.AnglePictureFrameBase.type]: Model.AnglePictureFrameSingleBase.type,
    [Model.ArchBase.type]: Model.ArchSingleBase.type,
    [Model.BoxFrameBase.type]: Model.BoxFrameBase.type,
    [Model.ConnectedXBase.type]: Model.ConnectedXBase.type,
    [Model.SlimConnectedXBase.type]: Model.SlimConnectedXSingleBase.type,
    [Model.ReflectionBase.type]: Model.ReflectionCTCBase.type,
    [Model.SinglePostBase.type]: Model.SinglePostSingleBase.type,
    [Model.XMetalBase.type]: Model.XMetalSingleBase.type,
    [Model.TriflectionBase.type]: Model.TriflectionBase.type
};
export const DOUBLE_BASE_ALTERNATIVE_MAP = {
    [Model.AnchorSingleFeetBase.type]: Model.AnchorBase.type,
    [Model.BellhouseSingleFeetBase.type]: Model.BellhouseBase.type,
    [Model.BrewerSingleBase.type]: Model.BrewerBase.type,
    [Model.CraftsmanSingleBase.type]: Model.CraftsmanBase.type,
    [Model.CrescentSingleBase.type]: Model.CrescentBase.type,
    [Model.DanaSingleBase.type]: Model.DanaBase.type,
    [Model.FranklinSingleFeetBase.type]: Model.FranklinBase.type,
    [Model.MeredithSingleFeetBase.type]: Model.MeredithBase.type,
    [Model.OswaldSingleBase.type]: Model.OswaldBase.type,
    [Model.RishSingleBase.type]: Model.RishBase.type,
    [Model.RogersSinglePlatformBase.type]: Model.RogersBase.type,
    [Model.TamaraSingleBase.type]: Model.TamaraBase.type,
    [Model.TuscanSingleFeetBase.type]: Model.TuscanBase.type,
    [Model.WaldenSingleBase.type]: Model.WaldenBase.type,
    [Model.XSingleBase.type]: Model.XBase.type,
    [Model.AnglePictureFrameSingleBase.type]: Model.AnglePictureFrameBase.type,
    [Model.ArchSingleBase.type]: Model.ArchBase.type,
    [Model.SlimConnectedXSingleBase.type]: Model.SlimConnectedXBase.type,
    [Model.ReflectionCTCBase.type]: Model.ReflectionBase.type,
    [Model.SinglePostSingleBase.type]: Model.SinglePostBase.type,
    [Model.XMetalSingleBase.type]: Model.XMetalBase.type
};

//# sourceMappingURL=base-data.js.map